import { routes as configRoutes } from 'config/routes';
import { PageContext } from 'hooks/shared/usePageContext.types';

const routes = {
  home: configRoutes.home,
  sharedCandidatePage: configRoutes.sharedCandidatePage({
    userId: ':userId',
    campaignId: ':campaignId',
    candidateId: ':candidateId',
  }),
  candidatePage: configRoutes.candidatePage({
    userId: ':userId',
    campaignId: ':campaignId',
    candidateId: ':candidateId',
  }),
  centralInbox: configRoutes.centralInbox,
  ratedCandidates: configRoutes.ratedCandidates,
  campaignPage: configRoutes.search({ campaignId: ':id' }),
} as const;

const matchesRoute = (pathname: string, pattern: string): boolean => {
  const regexPattern = pattern.replace(/:[^/]+/g, '[^/]+');
  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(pathname);
};

export const getPageContext = (): PageContext => {
  if (typeof window === 'undefined') {
    throw new Error('getPageContext can only be used in a browser environment');
  }

  const pathname = window.location.pathname;

  if (matchesRoute(pathname, routes.sharedCandidatePage)) {
    return PageContext.Shared;
  }

  if (matchesRoute(pathname, routes.candidatePage)) {
    return PageContext.Candidate;
  }

  if (pathname === routes.home) {
    return PageContext.Home;
  }

  if (pathname === routes.ratedCandidates) {
    return PageContext.RatedCandidates;
  }

  if (pathname === routes.centralInbox) {
    return PageContext.CentralInbox;
  }

  return PageContext.Campaign;
};

export const getPageContextFromPath = (pathname: string): PageContext => {
  if (matchesRoute(pathname, routes.campaignPage)) {
    return PageContext.Campaign;
  }

  if (matchesRoute(pathname, routes.sharedCandidatePage)) {
    return PageContext.Shared;
  }

  if (matchesRoute(pathname, routes.candidatePage)) {
    return PageContext.Candidate;
  }

  if (pathname === routes.home) {
    return PageContext.Home;
  }

  if (pathname === routes.ratedCandidates) {
    return PageContext.RatedCandidates;
  }

  if (pathname === routes.centralInbox) {
    return PageContext.CentralInbox;
  }

  return PageContext.Other;
};
